import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ps-0" }
const _hoisted_2 = { class: "d-flex flex-column mb-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", { class: "texto mb-1" }, "Marca", -1)
const _hoisted_4 = { class: "d-flex flex-column mb-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", { class: "texto mb-1" }, "Modelo", -1)
const _hoisted_6 = { class: "d-flex flex-column mb-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", { class: "texto mb-1" }, "Tipo", -1)
const _hoisted_8 = { class: "d-flex flex-column mb-5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h6", { class: "texto mb-1" }, "EAN", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_FilterBase = _resolveComponent("FilterBase")!

  return (_openBlock(), _createBlock(_component_FilterBase, {
    id: "FilterFiltros",
    subtitle: "Faça filtros e aprimore sua busca",
    hideFilter: false,
    staticModal: false,
    hideClose: false,
    activeModal: false,
    closeModal: _ctx.closeModal,
    disabledClick: false,
    onSearch: _cache[4] || (_cache[4] = ($event: any) => (_ctx.enviarEmit()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        _createElementVNode("li", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_select, {
            placeholder: "Marca",
            type: "text",
            clearable: "",
            filterable: "",
            class: "",
            style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
            modelValue: _ctx.paramsFilter.marca,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paramsFilter.marca) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marcasDeFiltros, (marcaProd, key) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: marcaProd.nome,
                  value: marcaProd.id_marca_produto
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("li", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_input, {
            placeholder: "Modelo",
            clearable: "",
            type: "text",
            class: "",
            style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
            modelValue: _ctx.paramsFilter.filtro,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.paramsFilter.filtro) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("li", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_select, {
            modelValue: _ctx.paramsFilter.tipo,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paramsFilter.tipo) = $event)),
            placeholder: "Selecione um tipo para pesquisa",
            clearable: "",
            style: {"border":"1px solid rgb(181, 181, 195)","border-radius":"5px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiposDeFiltro, (tipoFiltro, key) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: tipoFiltro.descricao,
                  value: tipoFiltro.id_tipo_produto.toString()
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("li", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_el_input, {
            placeholder: "EAN",
            clearable: "",
            type: "text",
            class: "",
            style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
            modelValue: _ctx.paramsFilter.ean,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.paramsFilter.ean) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["closeModal"]))
}